// extracted by css-extract-rspack-plugin
export default {"imageWrapper":"ZoomableAsset-module__imageWrapper____KHg5","imageWrapperActive":"ZoomableAsset-module__imageWrapperActive___r3U9i","image":"ZoomableAsset-module__image___BqPQz"};